import api from '@/api'

const store = {
  state: {
    dataStoreOpenSchedule: [],
    openScheduleConfig: {},
    pagingStoreOpenSchedule: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingStoreOpenSchedule: {
      byField: '',
      isDesc: false
    },
    filteringStoreOpenSchedule: {
      outletCode: null,
      orderType: null,
      status: null,
      beginDate: null,
      endDate: null,
      beginDay: null,
      endDay: null,
      beginHour: null,
      endHour: null
    }
  },

  mutations: {
    SET_STOREOPENSCHEDULE: (state, payload) => {
      state.dataStoreOpenSchedule = payload
    },
    SET_OPEN_SCHEDULE_CONFIG: (state, payload) => {
      state.openScheduleConfig = payload
    },
    SET_PAGING_PAGE_STOREOPENSCHEDULE: (state, payload) => {
      state.pagingStoreOpenSchedule.page = payload
    },
    SET_PAGING_TOTAL_STOREOPENSCHEDULE: (state, payload) => {
      state.pagingStoreOpenSchedule.total = payload
    },
    SET_SORTING_STOREOPENSCHEDULE: (state, payload) => {
      state.sortingStoreOpenSchedule = payload
    },
    SET_FILTERING_STOREOPENSCHEDULE: (state, payload) => {
      state.filteringStoreOpenSchedule = payload
    }
  },

  getters: {
    SortingStoreOpenSchedule: state => state.sortingStoreOpenSchedule,
    FilteringStoreOpenSchedule: state => state.filteringStoreOpenSchedule,
    PagingStoreOpenSchedule: state => state.pagingStoreOpenSchedule,
    GetAllStoreOpenSchedule: state => state.dataStoreOpenSchedule,
    GetOneStoreOpenSchedule: state => id =>
      state.dataStoreOpenSchedule.find(
        dataStoreOpenSchedule => dataStoreOpenSchedule.id === id
      ),
    GetOpenScheduleConfig: state => state.openScheduleConfig
  },

  actions: {
    async UpdateSortingStoreOpenSchedule({ commit, dispatch }, payload) {
      commit('SET_SORTING_STOREOPENSCHEDULE', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllStoreOpenSchedule')
    },

    async UpdateFilteringStoreOpenSchedule({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_STOREOPENSCHEDULE', emptyFilter)
      }
      commit('SET_PAGING_PAGE_STOREOPENSCHEDULE', 1)
      dispatch('GetAllStoreOpenSchedule')
    },

    async GetAllStoreOpenSchedule({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllStoreOpenSchedule(
          state.pagingStoreOpenSchedule,
          state.sortingStoreOpenSchedule,
          state.filteringStoreOpenSchedule
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit(
          'SET_PAGING_TOTAL_STOREOPENSCHEDULE',
          result.headers['data-length']
        )
        commit('SET_STOREOPENSCHEDULE', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateStoreOpenSchedule({ dispatch }, payload) {
      try {
        const { data } = await api.CreateStoreOpenSchedule(payload)
        dispatch('GetAllStoreOpenSchedule')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateStoreOpenSchedule({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateStoreOpenSchedule(payload.id, payload)
        dispatch('GetAllStoreOpenSchedule')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteStoreOpenSchedule({ dispatch }, id) {
      try {
        const { data } = await api.DeleteStoreOpenSchedule(id)
        dispatch('GetAllStoreOpenSchedule')
        return data
      } catch (e) {
        return e.response
      }
    },

    async GetOpenScheduleConfig({ commit }) {
      try {
        const { data } = await api.GetOpenScheduleConfig()
        commit('SET_OPEN_SCHEDULE_CONFIG', data.result)
        return data
      } catch (e) {
        return e.response
      }
    }
  }
}

export default store
